
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dokumen/daftar/[id]",
      function () {
        return require("private-next-pages/dokumen/daftar/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dokumen/daftar/[id]"])
      });
    }
  